import request from '@/utils/request'

export function getBookList (data) {
  return request({
    url: `/platform/book/list`,
    method: 'get',
    data
  })
}

export function addBook (data) {
  return request({
    url: `/platform/book`,
    method: 'post',
    data
  })
}

export function editBook (data) {
  return request({
    url: `/platform/book/${data.id}`,
    method: 'patch',
    data
  })
}

export function delBook (id) {
  return request({
    url: `platform/book/${id}`,
    method: 'delete'
  })
}



// WEBPACK FOOTER //
// ./src/api/book.js